import { createFileRoute } from '@tanstack/react-router'

import { TenantsListPage } from '@/pages/tenants/TenantsListPage'

export const Route = createFileRoute('/_authenticated/tenants/')({
  component: TenantsListPage,
})
